// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WV5o1{display:flex;align-items:center;justify-content:center;gap:24px;position:relative;--draggable-grid-item-radius: 8px}.WV5o1:not(:empty){margin-bottom:12px}.ddznE .WV5o1{gap:8px}.oDhym{width:210px;min-height:34px;background:#f5f7fd;border-radius:8px;padding:4px 4px;border:1px solid #bfbfd0;display:flex;align-items:center;justify-content:space-between;gap:8px;text-align:start}.oDhym[aria-selected=true]{background:#dae0ff}.ddznE .oDhym{width:100%}.WGhUT{flex-shrink:0}.Zlj2b{flex:1;min-width:0}.eXmVR{margin-bottom:0}.CqlKB{background:transparent;outline:0;border:1px dashed #bfbfd0;border-radius:4px;margin:-1px}.KZM02{display:flex;flex-direction:column;align-items:center;gap:20px;text-align:center;border-radius:12px;border:1px solid #d4d4e0;padding:20px}.SGz2c{width:24px;display:flex;justify-content:center}.Gg4xC{text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"tabs": `WV5o1`,
	"mobile": `ddznE`,
	"tab": `oDhym`,
	"addPackageButton": `WGhUT`,
	"tabContent": `Zlj2b`,
	"form": `eXmVR`,
	"nameInput": `CqlKB`,
	"emptyStateContainer": `KZM02`,
	"iconContainer": `SGz2c`,
	"invalidWarning": `Gg4xC`
};
export default ___CSS_LOADER_EXPORT___;
